import React, { FC, useState } from 'react'
import AssignDialog, { AssignDialogProps } from '../components/AssignDialog'
import ConfirmDialog, { ConfirmDialogProps } from '../components/ConfirmDialog'
import EditDialog, { EditDialogProps } from '../components/EditDialog'
import SelectDialog, { SelectDialogProps } from '../components/SelectDialog'
import { hideDialog } from '../utils/DialogUtil'

const DialogContext = React.createContext({
  confirmDialogPropsSetter: (confirmDialogProps: ConfirmDialogProps) => {},
  editDialogPropsSetter: (editDialogProps: EditDialogProps) => {},
  assignDialogPropsSetter: (assignDialogProps: AssignDialogProps) => {},
  selectDialogPropsSetter: (selectDialogProps: SelectDialogProps) => {},
  closeAllDialog: () => {},
})

export const Dialogs: FC<{}> = ({ children }) => {
  const [confirmDialogProps, confirmDialogPropsSetter] = useState({} as ConfirmDialogProps)
  const [editDialogProps, editDialogPropsSetter] = useState({} as EditDialogProps)
  const [assignDialogProps, assignDialogPropsSetter] = useState({} as AssignDialogProps)
  const [selectDialogProps, selectDialogPropsSetter] = useState({} as SelectDialogProps)

  function closeAllDialog() {
    hideDialog(confirmDialogPropsSetter)
    hideDialog(editDialogPropsSetter)
    hideDialog(assignDialogPropsSetter)
    hideDialog(selectDialogPropsSetter)
  }

  return (
    <DialogContext.Provider
      value={{
        confirmDialogPropsSetter,
        editDialogPropsSetter,
        assignDialogPropsSetter,
        selectDialogPropsSetter,
        closeAllDialog,
      }}>
      {children}
      {confirmDialogProps?.show && <ConfirmDialog confirmDialogProps={confirmDialogProps} />}
      {editDialogProps?.show && <EditDialog editDialogProps={editDialogProps} />}
      {assignDialogProps?.show && <AssignDialog assignDialogProps={assignDialogProps} />}
      {selectDialogProps?.show && <SelectDialog selectDialogProps={selectDialogProps} />}
    </DialogContext.Provider>
  )
}

export default DialogContext
